import smile from "assets/images/banners/eyeInternal/smilepro.jpg";
import contoura from "assets/images/banners/eyeInternal/specremoval.jpg";
import catract from "assets/images/banners/eyeInternal/catract.jpg";
import gulcoma from "assets/images/banners/eyeInternal/glaucoma.jpg";
import cornea from "assets/images/banners/eyeInternal/cornea&karetoconous.jpg";
import pedia from "assets/images/banners/eyeInternal/pediatricopthalmology.jpg";
import retina from "assets/images/banners/eyeInternal/retina.jpg";
import oculo from "assets/images/banners/eyeInternal/oculoplastyandcosmaticenhancement.jpg";
import contace from "assets/images/banners/eyeInternal/contactlenses.jpg";
import neuro from "assets/images/banners/eyeInternal/neuroopthamology.jpg";
import lowvision from "assets/images/banners/eyeInternal/lowvisionsyndrome.jpg";

import cataractI from "assets/images/banners/eyeInternalBanner/cataract.png";
import contactLensesI from "assets/images/banners/eyeInternalBanner/contactLens.png";
import contoruaI from "assets/images/banners/eyeInternalBanner/contouraVision.png";
import corneaI from "assets/images/banners/eyeInternalBanner/cornea.png";
import glaucomaI from "assets/images/banners/eyeInternalBanner/glaucoma.png";
import lowvisionI from "assets/images/banners/eyeInternalBanner/lowVision.png";
import neuroI from "assets/images/banners/eyeInternalBanner/neuroOpth.png";
import oculoI from "assets/images/banners/eyeInternalBanner/oculo.png";
import pediaI from "assets/images/banners/eyeInternalBanner/pedia.png";
import retinaI from "assets/images/banners/eyeInternalBanner/retina.png";
import smileProI from "assets/images/banners/eyeInternalBanner/smilePro.png";

export const internalData = [
  {
    id: "smileProSurgery",
    label: "Smile Pro Surgery",
    img: smile,
    banner: smileProI,
    title: "SMILE Eye Surgery in Chennai – Safe & Painless Vision Correction",
    description: "Get advanced SMILE eye surgery with quick recovery, blade-free technology, and expert ophthalmologists. Book a consultation today.",
    keyword: "",
    data: [
      {
        header: "What is Smile Pro Surgery",
        content:
          "Smile Pro Surgery is the world’s first robotic flapless and minimally invasive laser vision correction procedure. It uses advanced laser technology to reshape the cornea with unparalleled precision, restoring perfect vision in just 9 seconds.",
        points: null,
      },
      {
        header: "Is Smile Pro Surgery Right for You?",
        content:
          "Ideal for those looking to eliminate the need for glasses or contact lenses, Smile Pro Surgery offers a quick, virtually pain-free solution with a rapid recovery time.",
        points: [
          "Minimal Discomfort: Suitable for those who want a virtually pain-free procedure.",
          "Fast Recovery: Ideal if you want to resume day-to-day activities quickly, usually within 24 hours.",
          "Freedom from Glasses: Great for anyone looking to enjoy a life free from glasses or contact lenses.",
        ],
      },
      {
        header: "How is Smile Pro Surgery Done?",
        content:
          "The Smile Pro Surgery involves making a keyhole incision for lenticule extraction. The precision laser technology reshapes the cornea in just 9 seconds.",
        points: [
          "Minimally Invasive: A tiny keyhole incision of just 3 mm.",
          "High Precision: Advanced laser technology reshapes the cornea.",
        ],
      },
    ],
faqsSection: {
    heading: "FAQs Section",
    services: [
      {
        label: "1.Why Choose Amrit Hospital for SMILE Pro Surgery?",
        content:
          " Amrit Hospital offers advanced SMILE Pro vision correction supported by experienced eye surgeons and modern laser technology, ensuring precise treatment and patient comfort.",
      },
      {
        label: "2. What Is SMILE Pro Surgery Offered at Amrit Hospital?",
        content:
          " SMILE Pro is a minimally invasive laser vision correction procedure designed to improve visual clarity with enhanced accuracy and faster recovery.",
      },
      {
        label: "3.Is SMILE Pro Surgery Safe at Amrit Hospital?",
        content:
          " Patient safety is ensured through advanced laser systems, detailed eye evaluations, and strict surgical protocols followed by trained ophthalmic specialists.",
      },
      {
        label: "4.Who Can Benefit From SMILE Pro Surgery?",
        content:
          " Patients seeking freedom from glasses or contact lenses may benefit after a comprehensive eye assessment conducted by our ophthalmology team.",
      },
      {
        label: "5. What Technology Is Used for SMILE Pro Surgery?",
        content:
          " Amrit Hospital utilizes advanced laser platforms and diagnostic tools to support precise correction and consistent outcomes.",
      },
      {
        label: "6.What Kind of Post-Procedure Care Is Provided?",
        content:
          " We provide structured post-surgery follow-up, vision monitoring, and guidance to support smooth healing and visual improvement.",
      },
      {
        label: "7. How Can I Schedule a Consultation for SMILE Pro Surgery?",
        content:
          " Appointments can be booked through our online system or by contacting the hospital directly for consultation with our eye specialists.",
      },
    ],
  },

  },
  {
    id: "contouraVision",
    label: "Contoura Vision - Specs Removal",
    img: contoura,
    banner: contoruaI,
     title: "Contoura Vision Correction in Chennai – Latest LASIK Technology",
    description: "Experience high-precision Contoura Vision surgery with Personalized treatment for sharpest vision correction. Book now.",
    keyword: "",
    data: [
      {
        header: "What is Contoura Vision Surgery?",
        content:
          "Contoura Vision is an advanced LASIK procedure that uses computer-guided topographic mapping to correct vision by addressing the microscopic contours of the cornea, providing superior visual acuity and refractive outcomes.",
        points: null,
      },
      {
        header: "Is Contoura Vision Surgery Right for You?",
        content:
          "Perfect for individuals looking to achieve better visual acuity than traditional LASIK, Contoura Vision is recommended for those with irregular corneal curvature and vision issues not adequately addressed by standard procedures.",
        points: [
          "Personalized Treatment: Ideal for those with unique corneal irregularities.",
          "Superior Visual Acuity: Suitable for anyone wanting better results than traditional LASIK.",
          "Customized Procedure: Perfect for individuals needing a highly tailored treatment plan.",
        ],
      },
      {
        header: "How is Contoura Vision Surgery Done?",
        content:
          "Contoura Vision uses a specially designed laser programmed with data from a topographic map of your cornea.",
        points: [
          "Topographic Mapping: Maps at least 22,000 points on your cornea.",
          "Custom Laser Application: Uses a laser designed specifically for your corneal contours.",
          "Precise Corrections: Treats vision irregularities with remarkable precision.",
        ],
      },
    ],
    faqsSection: {
    heading: "FAQs Section",
    services: [
      {
        label: "1. Why Is Amrit Hospital Preferred for Contoura Vision Treatment?",
        content:
          " Amrit Hospital delivers customized vision correction using advanced Contoura Vision technology supported by skilled ophthalmologists.",
      },
      {
        label: "2. What Is Contoura Vision Treatment?",
        content:
          " Contoura Vision is a personalized laser vision correction approach designed to improve visual clarity based on detailed corneal mapping.",
      },
      {
        label: "3. Is Contoura Vision Safe at Amrit Hospital?",
        content:
          " Yes, the procedure is performed using advanced laser systems with strict safety standards and expert clinical supervision.",
      },
      {
        label: "4. How Does Amrit Hospital Ensure Accuracy in Contoura Vision?",
        content:
          " We use high-precision diagnostic equipment to customize treatment for each patient’s eye structure.",
      },
      {
        label: "5. What Care Is Provided After Contoura Vision Treatment?",
        content:
          " Patients receive structured follow-up care and vision monitoring to support recovery and long-term results.",
      },
      {
        label: "6. Who Can Consider Contoura Vision Treatment?",
        content:
          "Eligibility is determined after a comprehensive eye evaluation conducted by our ophthalmology team.",
      },
      {
        label: "7. How Do I Book an Appointment for Contoura Vision?",
        content:
          " Consultations can be scheduled via phone or through our online appointment system.",
      },
    ],
  },
  },
  {
    id: "cataract",
    label: "Cataract",
    img: catract,
    banner: cataractI,
     title: "Best Cataract Surgery in Chennai – Blade-Free Eye Procedure",
    description: "Restore your vision with advanced cataract surgery in Chennai at Amrit Hospitals. Get treated by expert ophthalmologists. Painless & effective.",
    keyword: "",
    data: [
      {
        header: "What is Cataract Surgery?",
        content:
          "Cataract surgery is a procedure to remove the cloudy lens of the eye, which is replaced with an artificial lens to restore clear vision. This surgery addresses the common issue of cataracts that typically occur with aging.",
        points: null,
      },
      {
        header: "Is Cataract Surgery Right for You?",
        content:
          "Cataract surgery is recommended for individuals experiencing significant vision impairment due to cataracts, affecting daily activities like reading or driving.",
        points: [
          "Vision Restoration: Ideal for those with blurry or dim vision due to cataracts.",
          "Improved Quality of Life: Suitable for anyone struggling with daily tasks because of poor vision.",
          "Immediate Results: Perfect for those wanting quick improvement in vision clarity.",
        ],
      },
      {
        header: "How is Cataract Surgery Done?",
        content:
          "During cataract surgery, the cloudy lens is carefully removed, often with the assistance of laser technology for precision. The natural lens is then replaced with a clear artificial lens.",
        points: [
          "Lens Removal: The cloudy lens is carefully extracted.",
          "Laser Precision: Advanced laser technology ensures accurate surgery.",
          "Artificial Lens Implant: The natural lens is replaced with a clear, artificial lens.",
          "Quick Recovery: Performed under local anesthesia, allowing swift recovery and immediate vision improvement.",
        ],
      },
    ],

    faqsSection: {
    heading: "FAQs Section",
    services: [
      {
        label: "1.  Why Choose Amrit Hospital for Cataract Treatment?",
        content:
          " Amrit Hospital offers comprehensive cataract care supported by experienced ophthalmologists and modern surgical technology. Our focus is on safe treatment and improved visual outcomes for patients.",
      },
      {
        label: "2.. What Cataract Services Are Available at Amrit Hospital?",
        content:
          "  The hospital provides complete cataract care, including diagnosis, surgical treatment, and post-operative follow-up. Services are planned based on individual patient needs and eye health.",
      },
      {
        label: "3.  Is Cataract Surgery Safe at Amrit Hospital?",
        content:
          " Cataract surgery at Amrit Hospital follows strict safety protocols and is performed using advanced equipment. Detailed evaluations are conducted before surgery to ensure patient safety.",
      },
      {
        label: "4. What Technology Is Used for Cataract Treatment?",
        content:
          " Modern diagnostic tools and surgical systems are used to support accurate cataract removal and effective vision correction. This helps improve precision and recovery.",
      },
      {
        label: "5. What Post-Surgery Care Is Provided After Cataract Treatment?",
        content:
          " Patients receive structured post-operative care, including follow-up visits and recovery guidance. This ensures proper healing and long-term eye health.",
      },
      {
        label: "6. Does Amrit Hospital Treat Cataracts in Elderly Patients?",
        content:
          " Yes, cataract treatment is commonly provided for elderly patients with personalized care plans. The team ensures comfort and careful monitoring throughout the treatment process.",
      },
      {
        label: "7. How Can I Book an Appointment for Cataract Treatment?",
        content:
          " Appointments can be booked easily through the hospital’s online system or by contacting the hospital directly. The team will assist in scheduling a consultation with an eye specialist.",
      },
    ],
  },
  },
  {
    id: "glaucoma",
    label: "Glaucoma",
    img: gulcoma,
    banner: glaucomaI,
     title: "Glaucoma Specialists in Chennai – Eye Pressure Management",
    description: "Get expert glaucoma diagnosis and treatment in Chennai at Amrit Hospitals. Prevent vision loss with early detection and modern care. Book now.",
    keyword: "",
    data: [
      {
        header: "What is Glaucoma?",
        content:
          "Glaucoma is a group of eye conditions that damage the optic nerve, typically due to increased pressure inside the eye, leading to gradual vision loss if untreated.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Gradual Loss of Peripheral Vision",
          "Blurred Vision",
          "Halos around Lights",
          "Severe Eye Pain",
        ],
      },
      {
        header: "Possible Treatments",
        content:
          "Glaucoma can be managed and prevented by the following possible ways:",
        points: [
          "Medication: Prescription eye drops or oral medications to reduce intraocular pressure.",
          "Laser Therapy: Procedures like laser trabeculoplasty to improve fluid drainage.",
          "Surgical Options: Trabeculectomy or minimally invasive glaucoma surgery (MIGS) to create new drainage channels.",
        ],
      },
    ],
    faqsSection: {
    heading: "FAQs Section",
    services: [
      {
        label: "1.  Why Choose Amrit Hospital for Glaucoma Care?",
        content:
          " Amrit Hospital provides comprehensive glaucoma management with experienced ophthalmologists and advanced diagnostic support. Our focus is on early detection and long-term eye health preservation.",
      },
      {
        label: "2.  What Glaucoma Services Are Available at Amrit Hospital?",
        content:
          " Services include glaucoma screening, medical management, surgical care, and regular monitoring. Treatment plans are tailored based on the stage and severity of the condition.",
      },
      {
        label: "3. How Is Glaucoma Diagnosed at Amrit Hospital?",
        content:
          " Advanced diagnostic tools are used to measure eye pressure, assess optic nerve health, and monitor vision changes. This helps in accurate diagnosis and timely care.",
      },
      {
        label: "4.  Is Glaucoma Treatment Safe at Amrit Hospital?",
        content:
          " All glaucoma treatments follow established clinical protocols with patient safety as a priority. Our specialists ensure careful monitoring during every stage of care.",
      },
      {
        label: "5.  Does Amrit Hospital Provide Long-Term Glaucoma Management?",
        content:
          " Yes, long-term monitoring and follow-up care are an important part of glaucoma management. This helps in controlling progression and maintaining vision.",
      },
      {
        label: "6. Are Surgical Options Available for Glaucoma Treatment?",
        content:
          " Surgical treatment options are available when required and are recommended after thorough evaluation. Procedures are performed using modern techniques and equipment.",
      },
      {
        label: "7. How Can I Book an Appointment for Glaucoma Consultation?",
        content:
          " Appointments can be scheduled through the hospital’s online booking system or by contacting the hospital directly for assistance.",
      },
    ],
  },
  },
  {
    id: "corneaAndKeratoconus",
    label: "Cornea and Keratoconus",
    img: cornea,
    banner: corneaI,
     title: "Keratoconus & Corneal Treatment in Chennai | Advanced Eye Care",
    description: "Treat corneal disorders & keratoconus at Amrit Hospitals, Chennai. Access advanced eye care, cross-linking, and corneal transplants. Book today.",
    keyword: "",
    data: [
      {
        header: "What is Cornea and Keratoconus Care?",
        content:
          "Cornea and Keratoconus Care focuses on specialized treatments for conditions affecting the cornea, such as keratoconus, aimed at improving corneal health and enhancing visual outcomes through advanced therapies and surgical interventions.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Blurry or Distorted Vision",
          "Increased Sensitivity to Light",
          "Difficulty with Night Vision",
          "Frequent Changes in Eyeglass Prescription",
        ],
      },
      {
        header: "Possible Treatments",
        content: "Our treatments include:",
        points: [
          "Cross-Linking: Strengthening the cornea with UV light and riboflavin drops.",
          "Intacs: Implantation of small plastic rings to reshape the cornea.",
          "Corneal Transplant: Replacement of the damaged cornea with a healthy donor cornea, tailored to your specific needs.",
        ],
      },
    ],
   faqsSection: {
  heading: "FAQs Section",
  services: [
    {
      label: "1. Why Choose Amrit Hospital for Cornea and Keratoconus Care?",
      content:
        "Amrit Hospital offers specialized care for corneal conditions with experienced ophthalmologists and advanced diagnostic tools. Patient comfort and safety are a top priority.",
    },
    {
      label: "2. What Corneal Services Are Available at Amrit Hospital?",
      content:
        "Services include evaluation, medical management, and surgical treatment for various corneal disorders. Personalized care plans are provided for every patient.",
    },
    {
      label: "3. How Is Keratoconus Managed at Amrit Hospital?",
      content:
        "Treatment is tailored based on the severity of keratoconus, using advanced procedures and monitoring to preserve vision and prevent progression.",
    },
    {
      label: "4. Are Advanced Diagnostic Facilities Available?",
      content:
        "Yes, the hospital uses state-of-the-art imaging and diagnostic equipment to accurately assess corneal conditions for effective treatment.",
    },
    {
      label: "5. Does Amrit Hospital Offer Corneal Surgery?",
      content:
        "Surgical options are available when necessary and are performed by skilled specialists following strict safety protocols.",
    },
    {
      label: "6. What Post-Treatment Care Is Provided?",
      content:
        "Patients receive follow-up visits, vision monitoring, and guidance to ensure smooth recovery and maintain eye health.",
    },
    {
      label: "7. How Can I Book a Cornea Consultation?",
      content:
        "Appointments can be booked online or by contacting the hospital directly, ensuring timely consultation with a cornea specialist.",
    },
  ],
}, 
  },
  {
    id: "pediatricOphthalmology",
    label: "Pediatric Ophthalmology",
    img: pedia,
    banner: pediaI,
     title: "Pediatric Eye Specialist in Chennai – Trusted Child Eye Care",
    description: "Ensure your child’s eye health with top pediatric ophthalmologists in Chennai at Amrit Hospitals. Book expert vision care for kids today.",
    keyword: "",
    data: [
      {
        header: "What is Pediatric Ophthalmology?",
        content:
          "Pediatric Ophthalmology involves specialized eye care tailored specifically for children, addressing a wide range of vision issues from infancy through adolescence. This field focuses on early detection, diagnosis, and treatment of conditions that can affect visual development, ensuring optimal eye health and function as children grow.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Frequent Squinting or Blinking",
          "Difficulty Reading or Seeing Objects up Close",
          "Poor Hand-Eye Coordination",
          "Inability to Maintain Eye Contact",
        ],
      },
      {
        header: "Possible Treatments",
        content: "Our pediatric ophthalmologists provide:",
        points: [
          "Glasses or Contacts: Correcting refractive errors such as nearsightedness or astigmatism.",
          "Vision Therapy: Exercises and activities to improve eye muscle strength and coordination.",
          "Surgical Intervention: Procedures to correct strabismus (crossed eyes) or congenital cataracts, ensuring comprehensive care for young patients.",
        ],
      },
    ],
faqsSection: {
  heading: "FAQs Section",
  services: [
    {
      label: "1. Why Choose Amrit Hospital for Pediatric Eye Care?",
      content:
        "Our pediatric ophthalmology team provides child-friendly eye care using modern technology and experienced specialists. Safety and comfort are prioritized.",
    },
    {
      label: "2. What Pediatric Eye Services Are Offered?",
      content:
        "We provide vision screening, diagnosis, treatment, and ongoing follow-up for children’s eye conditions.",
    },
    {
      label: "3. Is Pediatric Eye Care Safe at Amrit Hospital?",
      content:
        "Yes, all procedures follow child-specific safety protocols and are conducted by trained pediatric eye specialists.",
    },
    {
      label: "4. Are Vision Problems in Children Treated Here?",
      content:
        "Yes, a wide range of pediatric vision issues, including refractive errors and eye disorders, are managed with tailored care plans.",
    },
    {
      label: "5. Are Child-Friendly Facilities Available?",
      content:
        "Our environment is designed to be comfortable and reassuring for children and their families during consultations and treatments.",
    },
    {
      label: "6. Is Long-Term Pediatric Eye Monitoring Provided?",
      content:
        "Yes, ongoing follow-up ensures early detection of vision changes and continued eye health.",
    },
    {
      label: "7. How Can Parents Book an Appointment?",
      content:
        "Appointments can be booked online or by contacting the hospital directly for consultation with a pediatric ophthalmologist.",
    },
  ],
},
  },
  {
    id: "retina",
    label: "Retina",
    img: retina,
    banner: retinaI,
     title: "Retina Treatment in Chennai – Expert Eye Specialists",
    description: "Receive specialized retina care in Chennai at Amrit Hospitals. Diagnosis and treatment for retinal detachment, diabetic retinopathy & more.",
    keyword: "",
    data: [
      {
        header: "What is Retina Ophthalmology?",
        content:
          "Retina care involves the diagnosis, treatment, and management of various conditions affecting the retina, a critical layer of tissue at the back of the eye responsible for converting light into neural signals for vision. This specialized field addresses a range of retinal disorders, such as macular degeneration, diabetic retinopathy, retinal detachment, and more.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Floaters or Spots in Vision",
          "Flashes of Light",
          "Sudden Loss of Vision",
          "Distorted or Wavy Vision",
        ],
      },
      {
        header: "Possible Treatments",
        content: "Our retina specialists offer:",
        points: [
          "Intravitreal Injections: Medications injected directly into the eye to treat retinal conditions.",
          "Laser Therapy: Procedures to seal or repair retinal tears or blood vessels.",
          "Vitrectomy: Surgical removal of the vitreous gel to treat severe retinal conditions and ensure comprehensive retinal care.",
        ],
      },
    ],
    faqsSection: {
  heading: "FAQs Section",
  services: [
    {
      label: "1. Why Choose Amrit Hospital for Retina Care?",
      content:
        "Amrit Hospital offers specialized retina care using advanced imaging and treatment techniques performed by experienced ophthalmologists.",
    },
    {
      label: "2. What Retina Services Are Available?",
      content:
        "Services include diagnosis, medical management, and surgical treatment for retinal diseases and conditions.",
    },
    {
      label: "3. How Are Retina Conditions Diagnosed?",
      content:
        "Modern imaging systems are used to assess retinal health and guide precise treatment plans.",
    },
    {
      label: "4. Is Retina Treatment Safe at Amrit Hospital?",
      content:
        "All treatments follow strict clinical protocols to ensure safety and effectiveness for every patient.",
    },
    {
      label: "5. Does Amrit Hospital Provide Long-Term Retina Care?",
      content:
        "Yes, regular monitoring and follow-up care are provided to maintain eye health and prevent complications.",
    },
    {
      label: "6. Are Advanced Treatments Available for Retinal Disorders?",
      content:
        "Yes, the hospital offers modern medical and surgical solutions tailored to individual patient needs.",
    },
    {
      label: "7. How Can I Book a Retina Consultation?",
      content:
        "Appointments can be scheduled online or by contacting the hospital directly for a retina specialist consultation.",
    },
  ],
},
  },
  {
    id: "oculoplastyAndCosmeticEnhancement",
    label: "Oculoplasty and Cosmetic Enhancement",
    img: oculo,
    banner: oculoI,
     title: "Oculoplasty & Cosmetic Eye Surgery in Chennai",
    description: "Get expert oculoplasty and cosmetic enhancement procedures at Amrit Hospitals. Treat eyelid issues, eye tumors & more. Book consultation now.",
    keyword: "",
    data: [
      {
        header: "What is Oculoplasty and Cosmetic Enhancement?",
        content:
          "Oculoplasty and Cosmetic Enhancement involve surgical procedures focused on the eyelids, tear ducts, and orbit (bony socket around the eye), as well as non-surgical treatments to improve the appearance and function of the eyes and surrounding structures.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Drooping Eyelids",
          "Excessive Tearing",
          "Puffiness or Bags under Eyes",
          "Wrinkles or Fine Lines around Eyes",
        ],
      },
      {
        header: "Possible Treatments",
        content: "Our oculoplasty and cosmetic enhancement services include:",
        points: [
          "Blepharoplasty: Surgery to remove excess skin or fat from the eyelids.",
          "Botox Injections: Non-surgical treatment to reduce wrinkles and fine lines.",
          "Tear Duct Surgery: Procedures to clear blocked tear ducts, ensuring both functional and aesthetic improvements.",
        ],
      },
    ],
    faqsSection: {
  heading: "FAQs Section",
  services: [
    {
      label: "1. Why Choose Amrit Hospital for Oculoplasty Services?",
      content:
        "Amrit Hospital provides specialized oculoplasty procedures for both functional and cosmetic eye care, handled by experienced surgeons.",
    },
    {
      label: "2. What Oculoplasty Services Are Offered?",
      content:
        "Services include eyelid surgeries, tear duct procedures, and cosmetic eye enhancements tailored to patient needs.",
    },
    {
      label: "3. Is Oculoplasty Treatment Safe?",
      content:
        "All procedures follow strict safety protocols and are performed by skilled ophthalmic surgeons.",
    },
    {
      label: "4. Are Cosmetic Eye Enhancements Available?",
      content:
        "Yes, aesthetic procedures are offered with care to ensure natural outcomes and patient satisfaction.",
    },
    {
      label: "5. What Pre-Procedure Evaluation Is Conducted?",
      content:
        "Comprehensive assessments are carried out to plan procedures safely and effectively.",
    },
    {
      label: "6. What Post-Treatment Care Is Provided?",
      content:
        "Follow-up care includes recovery monitoring and guidance to ensure optimal results.",
    },
    {
      label: "7. How Can I Schedule an Oculoplasty Consultation?",
      content:
        "Appointments can be booked online or by contacting the hospital directly.",
    },
  ],
},
  },
  {
    id: "contactLenses",
    label: "Contact Lenses",
    img: contace,
    banner: contactLensesI,
     title: "Get Contact Lenses in Chennai – Personalized Eye Fit",
    description: "Explore a wide range of contact lenses at Amrit Hospitals, Chennai. Perfect fit, advanced testing & vision correction. Schedule an eye test today.",
    keyword: "",
    data: [
      {
        header: "What is Contact Lens Care?",
        content:
          "Contact Lens Care involves the fitting, prescription, and maintenance of contact lenses to correct various vision problems such as nearsightedness, farsightedness, astigmatism, and presbyopia. It encompasses a range of lens types and wearing schedules tailored to individual needs.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Discomfort or Irritation",
          "Redness or Swelling",
          "Blurred Vision",
          "Dry Eyes",
        ],
      },
      {
        header: "Possible Treatments",
        content: "Our contact lens care services include:",
        points: [
          "Custom Fittings: Personalized fittings for optimal comfort and vision.",
          "Specialty Lenses: Options like multifocal, toric, or rigid gas permeable lenses.",
          "Ongoing Care: Regular check-ups to monitor eye health and lens performance, ensuring comprehensive contact lens management.",
        ],
      },
    ],
      faqsSection: {
  heading: "FAQs Section",
  services: [
    {
      label: "1. Why Choose Amrit Hospital for Contact Lens Services?",
      content:
        "Amrit Hospital offers professional contact lens fitting and eye assessments by experienced specialists to ensure comfort and safety.",
    },
    {
      label: "2. What Contact Lens Services Are Available?",
      content:
        "Services include evaluation, fitting, prescription guidance, and lens care instructions.",
    },
    {
      label: "3. Is Professional Fitting Important for Contact Lenses?",
      content:
        "Yes, proper fitting ensures optimal comfort, safety, and long-term eye health.",
    },
    {
      label: "4. Are Follow-Up Services Provided After Fitting?",
      content:
        "Yes, patients receive follow-up support to monitor eye health and lens comfort.",
    },
    {
      label: "5. Are Specialized Contact Lenses Available?",
      content:
        "Specialized lenses, including corrective and therapeutic types, are provided as needed.",
    },
    {
      label: "6. How Does the Hospital Ensure Eye Safety?",
      content:
        "All fittings follow strict clinical hygiene protocols, and patients are guided on safe usage.",
    },
    {
      label: "7. How Can I Book a Contact Lens Appointment?",
      content:
        "Appointments can be scheduled online or through direct hospital contact.",
    },
  ],
},
  },
  {
    id: "neuroOphthalmology",
    label: "Neuro Ophthalmology",
    img: neuro,
    banner: neuroI,
     title: "Neuro-Ophthalmology Experts in Chennai – Eye & Brain Care",
    description: "Consult leading neuro-ophthalmologists in Chennai at Amrit Hospitals. Specialized care for optic nerve disorders & visual pathway issues.",
    keyword: "",
    data: [
      {
        header: "What is Neuro Ophthalmology?",
        content:
          "Neuro Ophthalmology focuses on the complex relationship between the eyes and the brain, diagnosing and managing visual problems related to the nervous system, including optic nerve disorders, visual field loss, and neurological diseases affecting vision.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Sudden Vision Loss",
          "Double Vision",
          "Visual Field Loss",
          "Eye Movement Disorders",
        ],
      },
      {
        header: "Possible Treatments",
        content: "Our neuro ophthalmologists provide:",
        points: [
          "Comprehensive Evaluation: Detailed assessments to identify the underlying neurological causes of visual symptoms.",
          "Medical Management: Treatments for conditions like optic neuritis, myasthenia gravis, and pseudotumor cerebri.",
          "Surgical Interventions: Procedures to address issues such as optic nerve compression or eye movement abnormalities, ensuring integrated care for complex visual disorders.",
        ],
      },
    ],
    faqsSection: {
  heading: "FAQs Section",
  services: [
    {
      label: "1. Why Choose Amrit Hospital for Neuro-Ophthalmology Care?",
      content:
        "Amrit Hospital provides specialized care for complex vision and neurological conditions, handled by experienced ophthalmologists and neurologists.",
    },
    {
      label: "2. What Neuro-Ophthalmology Services Are Available?",
      content:
        "Services include evaluation, diagnosis, and management of vision issues linked to neurological disorders.",
    },
    {
      label: "3. Is Advanced Diagnostic Support Available?",
      content:
        "Yes, modern diagnostic tools are used to accurately assess and monitor neurological eye conditions.",
    },
    {
      label: "4. Does Amrit Hospital Offer Multidisciplinary Care?",
      content:
        "Care is coordinated with other specialists, ensuring comprehensive management of complex conditions.",
    },
    {
      label: "5. Is Patient Safety Prioritized?",
      content:
        "Strict clinical protocols and expert supervision ensure safe and effective care.",
    },
    {
      label: "6. Are Long-Term Monitoring Services Provided?",
      content:
        "Yes, patients receive ongoing follow-up and care plans tailored to their condition.",
    },
    {
      label: "7. How Can I Book a Neuro-Ophthalmology Appointment?",
      content:
        "Appointments can be booked online or by contacting the hospital directly to consult with a neuro-ophthalmology specialist.",
    },
  ],
},
  },
  {
    id: "lowVisionSyndrome",
    label: "Low Vision Syndrome",
    img: lowvision,
    banner: lowvisionI,
     title: "Low Vision Syndrome Treatment in Chennai – Improve Your Vision",
    description: "Regain visual function with low vision rehabilitation in Chennai at Amrit Hospitals. Personalized aids and therapy for vision enhancement.",
    keyword: "",
    data: [
      {
        header: "What is Low Vision Syndrome?",
        content:
          "Low Vision Syndrome involves significant visual impairment that cannot be fully corrected with glasses, contact lenses, or surgery, often resulting from conditions such as macular degeneration, glaucoma, diabetic retinopathy, or congenital disorders. This condition affects daily functioning and quality of life.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Difficulty Recognizing Faces",
          "Trouble Reading or Seeing Details",
          "Loss of Central or Peripheral Vision",
          "Struggling with Bright or Low Light Conditions",
        ],
      },
      {
        header: "Possible Treatments",
        content: "Our low vision services include:",
        points: [
          "Vision Rehabilitation: Training and tools to maximize remaining vision.",
          "Assistive Devices: Magnifiers, special glasses, and electronic aids.",
          "Adaptive Techniques: Strategies to enhance daily living skills and independence, ensuring comprehensive support for low vision individuals.",
        ],
      },
    ],

    faqsSection: {
    heading: "FAQs Section",
    services: [
      {
        label: "1. Why Choose Amrit Hospital for Low Vision Care?",
        content:
          " Amrit Hospital provides supportive care for patients with reduced vision, helping them maintain independence and quality of life.",
      },
      {
        label: "2. What Low Vision Services Are Available?",
        content:
          " Services include assessment, visual aids, and personalized care plans for patients with low vision.",
      },
      {
        label: "3. How Is Low Vision Evaluated?",
        content:
          " Advanced diagnostic tools are used to assess vision loss and identify suitable support options.",
      },
      {
        label: "4. Are Assistive Solutions Provided?",
        content:
          " Yes, patients are offered customized visual aids and strategies to enhance daily functioni",
      },
      {
        label: "5.  Is Long-Term Support Available?",
        content:
          " Ongoing care and monitoring are provided to ensure continuous visual assistance.",
      },
      {
        label: "6. Does the Hospital Treat All Age Groups?",
        content:
          " Low vision care is available for children, adults, and the elderly with tailored solutions.",
      },
      {
        label: "7. How Can I Schedule a Low Vision Consultation?",
        content:
          "Appointments can be booked online or by contacting the hospital directly for personalized evaluation.",
      },
    ],
  },

  },
  
];

export const list = [
  {
    id: "smileProSurgery",
    label: "Smile Pro Surgery",
    content: "datamap",
  },
  {
    id: "contouraVision",
    label: "Contoura Vision - Specs Removal",
    content: "datamap",
  },
  {
    id: "cataract",
    label: "Cataract",
    content: "datamap",
  },
  {
    id: "glaucoma",
    label: "Glaucoma",
    content: "datamap",
  },
  {
    id: "corneaAndKeratoconus",
    label: "Cornea and Keratoconus",
    content: "datamap",
  },
  {
    id: "pediatricOphthalmology",
    label: "Pediatric Ophthalmology",
    content: "datamap",
  },
  {
    id: "retina",
    label: "Retina",
    content: "datamap",
  },
  {
    id: "oculoplastyAndCosmeticEnhancement",
    label: "Oculoplasty and Cosmetic Enhancement",
    content: "datamap",
  },
  {
    id: "contactLenses",
    label: "Contact Lenses",
    content: "datamap",
  },
  {
    id: "neuroOphthalmology",
    label: "Neuro Ophthalmology",
    content: "datamap",
  },
  {
    id: "lowVisionSyndrome",
    label: "Low Vision Syndrome",
    content: "datamap",
  },
];

export const listheader = "Our Eye Care specialties";

export const opthomologyInternal = { list, internalData, listheader };
